import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('department/index', {params});
    },
    getDepartment(params) {
        return Service().get('department/get-department', {params});
    },
    show(id) {
        return Service().get('department/show/'+id);
    },
    create(params) {
        return Service().post('department/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('department/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('department/delete/'+id);
    },
}